<div class="container-fluid">
    <div class="row col-md-12 d-flex bg-white">
      <p-tabView [activeIndex]="activeTabIndex" class="summaryTask-tab w-100" (onChange)="handleChange($event)">
        <p-tabPanel [disabled]="true"
          *ngFor="let item of tabsList; let i = index;">
          <ng-template pTemplate="header">
            <div class="row">
              <hr class="tabLine" *ngIf="i !== 0" style="width: 33%;position: absolute;top: 2rem;" />
              <span class="header-icon border rounded-circle p-3" 
              [ngClass]="{'active':i == activeTabIndex, 'inactive':i !==activeTabIndex}" >
                <b class="tabNumber"> {{i + 1}}</b>
              </span>
              <hr *ngIf="i !== tabsList.length - 1" style="width: 33%;position: absolute;top: 2rem;right:0" />
            </div>
            <label>{{ item.tabName }}</label>
          </ng-template>
          <ng-template pTemplate="content"> 
            <div [ngSwitch]="i">
              <div *ngIf="this.data; else blankForm">
                <app-edit-client-company-form *ngSwitchCase="0" (notify)="parentListener($event)" [formCompanyData]="this.data" [companyId]="companyId"></app-edit-client-company-form>
              </div>

              <ng-template #blankForm>
                <app-add-client-company-form *ngSwitchCase="0" (notify)="parentListener($event)" [companyId]="companyId"></app-add-client-company-form>
              </ng-template>

              <app-add-user *ngSwitchCase="1" (notify)="parentListener($event)" [companyId]="companyId"></app-add-user>
            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>      